module.exports = __webpack_public_path__ + "static/media/katarina-lose.5c1126e0.png";